/**
 * Fixed-timestep accumulator. The simulation always advances in `dt` sized
 * steps; rendering interpolates with the returned alpha. Frame spikes are
 * clamped so a stalled tab does not trigger a "spiral of death".
 */
export class FixedStep {
  private acc = 0;

  constructor(
    readonly dt: number,
    private readonly maxStepsPerFrame = 5,
  ) {}

  /** Advances by real elapsed seconds; returns interpolation alpha in [0,1). */
  advance(elapsed: number, step: (dt: number) => void): number {
    this.acc += Math.min(Math.max(elapsed, 0), this.dt * this.maxStepsPerFrame);
    let steps = 0;
    while (this.acc >= this.dt && steps < this.maxStepsPerFrame) {
      step(this.dt);
      this.acc -= this.dt;
      steps++;
    }
    if (steps >= this.maxStepsPerFrame) this.acc = 0;
    return this.acc / this.dt;
  }

  reset(): void {
    this.acc = 0;
  }
}
